export const getRoutes = c => ({
  name: c.name,
  path: `${c.parentPath}${c.path}`,
  children: c.children ? c.children.filter(c => !c.skip).map(getRoutes) : undefined
});